import React from 'react';
import { Box, Button, Modal } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  initialUserSearchState,
  useUserSearchContext,
} from 'context/UserSearchContext';

interface CancelBookingProp {
  open: boolean;
  handleClose: () => void;
}
export const CancelBooking: React.FC<CancelBookingProp> = ({
  open,
  handleClose,
}) => {
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const locationCode = queryParams.get('locationCode');
  const { setBookingSearchData } = useUserSearchContext();
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="contentContainer">
        <h2 id="parent-modal-title" className="title">
          Are you sure to cancel?
        </h2>
        <p id="parent-modal-description" className="description">
          All your information & booking details will be lost.
        </p>
        <Button
          className="cancel-btn btn"
          onClick={() => {
            setBookingSearchData({ ...initialUserSearchState });
            navigate(
              `${locationCode ? '/?locationCode=' + locationCode : '/'}`
            );
          }}
        >
          {' '}
          {/* nft */}
          YES, CANCEL BOOKING
        </Button>
      </Box>
    </Modal>
  );
};
